





import { Component, Vue, Watch } from "vue-property-decorator";
import VueTheMask from "vue-the-mask";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";

// eslint-disable-next-line import/no-extraneous-dependencies
import "sweetalert2/dist/sweetalert2.min.css";

import { patchClassValidatorI18n } from "./models/validation/translateErrors";

const VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: -50,
	force: true,
	cancelable: false,
});

Vue.use(VueTheMask);
Vue.use(VueSweetalert2);
Vue.component("v-select", vSelect);

@Component({
	name: "App",
})
export default class App extends Vue {
	@Watch("$route")
	routeChange(route) {
		if (Object.keys(this.$i18n.messages).indexOf(route.params.locale) < 0) { // redirect to PageNotFound if the locale is not valid
			this.$router.replace(`/${this.$i18n.locale}/404`);
		} else if (route.params.locale !== this.$i18n.locale) { // change locale
			this.$i18n.locale = route.params.locale;
			patchClassValidatorI18n(route.params.locale); // patch class validator messages
		}
	}
}
